import commonUtils from 'top20common/distribution/utils';

export default function(analytics) {
  return {
    trackLoginClicked(isButtonDisabled) {
      analytics.trackEvent({
        action: 'Login Clicked',
        properties: {
          'button state': isButtonDisabled ? 'disabled' : 'active'
        }
      });
    },

    trackLoginError(error) {
      let isServerError = error.status.toString().startsWith('5');

      analytics.trackEvent({
        action: 'Login Error',
        properties: {
          'error code': error.status,
          'error type': isServerError ? 'server-side' : 'validation',
          errors: commonUtils.getErrorsFromResponse(error)
        }
      });
    },

    trackLoginFromRegisterClicked() {
      analytics.trackEvent({action: 'Login From Register Clicked'});
    },

    trackSignUpClicked(userType) {
      analytics.trackEvent({action: `Sign Up As ${userType.charAt(0).toUpperCase() + userType.slice(1)} Clicked`});
    },

    trackRegularSignUpClicked(isButtonDisabled) {
      analytics.trackEvent({
        action: 'Sign Up Clicked',
        properties: {
          'button state': isButtonDisabled ? 'disabled' : 'active'
        }
      });
    },

    trackSignUpError(error) {
      let isServerError = error.status.toString().startsWith('5');

      analytics.trackEvent({
        action: 'Sign Up Error',
        properties: {
          'error code': error.status,
          'error type': isServerError ? 'server-side' : 'validation',
          errors: commonUtils.getErrorsFromResponse(error)
        }
      });
    },

    trackLinkedInSignUpClicked(action) {
      analytics.trackEvent({
        action: 'LinkedIn Sign up',
        properties: {
          type: action === 'refer' ? 'referrer' : 'candidate'
        }
      });
    }
  };
}
